import { RadioOptionInterface } from '../types'

export const RADIO_NAME = 'radio-website-logo-link'
export const radioValueList = {
  homepage: 'homepage',
  custom: 'custom',
} as const

export const radioList: RadioOptionInterface[] = [
  {
    label: 'components.website_logo.settings.link.homepage',
    value: radioValueList.homepage,
  },
  {
    label: 'components.website_logo.settings.link.custom_url',
    value: radioValueList.custom,
  },
]
